export default __webpack_public_path__ + "static/media/Aeonik-Thin.1df1d2a2.ttf";